import { render } from "./CreateEditCompanyModal.vue?vue&type=template&id=5b8ea874"
import script from "./CreateEditCompanyModal.vue?vue&type=script&lang=js"
export * from "./CreateEditCompanyModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-reports\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__